const formatDate = (isoDateString: string): string => {
  if (!isoDateString) return "";
  
  const date = new Date(isoDateString);
  
  // Check if date is invalid
  if (isNaN(date.getTime())) return "";
  
  // Check if it's Unix epoch (January 1, 1970)
  if (date.getTime() === 0) return "";
  
  const day = date.getDate(); // 4
  const month = date.toLocaleString("default", { month: "short" }); // Aug
  const year = date.getFullYear(); // 2025

  return `${day} ${month} ${year}`;
};

export const formatDateTime = (isoDateString: string): string => {
  const date = new Date(isoDateString);

  // Day with suffix
  const day = date.getDate();
  const daySuffix = (d: number) => {
    if (d > 3 && d < 21) return "th"; // 4-20
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Time in hh:mm AM/PM
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}${daySuffix(day)} ${month} ${year} at ${hours}:${minutes} ${ampm}`;
};

// Format time like "At 2:30 PM"
export const formatTime = (timeString: string): string => {
  if (!timeString) return "";
  
  // Check if it's a simple time string (HH:MM format) from HTML time input
  if (timeString.includes(':') && timeString.length <= 5) {
    const [hours, minutes] = timeString.split(':').map(Number);
    
    // Validate hours and minutes
    if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return "";
    }
    
    const formattedMinutes = String(minutes).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12; // 0  12
    
    return `${displayHours}:${formattedMinutes} ${ampm}`;
  }
  
  // Handle ISO date string or other formats
  const date = new Date(timeString);
  
  // Check if date is invalid
  if (isNaN(date.getTime())) return "";
  
  // Check if it's Unix epoch (January 1, 1970)
  if (date.getTime() === 0) return "";

  let hours = date.getHours();
  let minutes = date.getMinutes();

  // Handle missing or invalid minutes
  if (isNaN(minutes)) minutes = 0;

  const formattedMinutes = String(minutes).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0  12

  return `${hours}:${formattedMinutes} ${ampm}`;
};



export function maskedSecretKey(key: string) {
  const maskedCode = key?.toString()?.slice(0, 6);
  const formattedCode = maskedCode
    ? `${maskedCode[0]}**********${maskedCode.slice(-1)}`
    : "";
  return formattedCode;
}

export const getFileNameFromUrl = (url: string): string => {
  return decodeURIComponent(url?.split("/")?.pop()?.split("?")[0] || "");
};

export function getFileExtension(url: any): string {
  try {
    const pathname = new URL(url).pathname;
    return pathname.split(".").pop()?.toLowerCase() || "";
  } catch (error) {
    return ""; // Return empty string if input is not a valid URL
  }
}

export default formatDate;
